/**
 * Normalizes GET /agent-sessions/{id} response into a stable snapshot shape.
 */
import {getStrategyDocumentFromSession} from '../utils/sessionDocuments';

export function normalizeCampaignSnapshot(sessionDetail) {
  if (!sessionDetail) {
    return null;
  }

  const revision =
    sessionDetail.workflow?.revision ||
    (sessionDetail.updatedAt
      ? new Date(sessionDetail.updatedAt).toISOString()
      : null);

  return {
    sessionId: sessionDetail.uuid,
    revision,
    messages: sessionDetail.messages ?? [],
    briefing: sessionDetail.userInput ?? null,
    strategy: getStrategyDocumentFromSession(sessionDetail.documents),
    arts: sessionDetail.medias ?? [],
    workflow: sessionDetail.workflow ?? null,
    status: sessionDetail.status ?? 'active',
  };
}

export function isSnapshotNewer(localRevision, incomingRevision) {
  if (!incomingRevision) {
    return false;
  }
  if (!localRevision) {
    return true;
  }
  return new Date(incomingRevision).getTime() >= new Date(localRevision).getTime();
}
